import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from '@tmapy/style-guide';
export class DateForm extends React.PureComponent {
    render() {
        return (_jsx(DatePicker, { value: this.props.date, isInvalid: this.props.date ? isNaN(this.props.date.getDate()) : false, onChange: this.props.onChange }));
    }
}
//# sourceMappingURL=form.js.map